import { OnInit, Component, Input, SimpleChanges, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { Router } from '@angular/router';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { VisitaModel } from 'src/app/models/visita.model';
import { VisitanteDTO, VisitantePK } from 'src/app/models/visitanteDTO.model';
import { ParametrosUACModel } from 'src/app/models/parametrosUAC.model';
import { AgendaVirtualModel } from 'src/app/models/agendaVirtual.model';
import { TramiteUACModel } from 'src/app/models/tramiteUAC.model';
import { TurnoUACModel } from 'src/app/models/turnoUAC.model';
import { TurnoGeneradoModel } from 'src/app/models/turnoGenerado.model';
import { ComponenteCameraComponent } from 'src/app/shared/components/informacionVisitante/componente-camera.component';
import { TurnoImpresoDTO } from 'src/app/models/turnoImpresoDTO.model';
import { AppSettings } from 'src/app/app.settings';
import { DomSanitizer } from '@angular/platform-browser';

declare var $: any;

@Component({
    selector: 'app-registro-ciudadano-UAC',
    templateUrl: './registro-ciudadano-UAC.component.html',
    styleUrls: ['./registro-ciudadano-UAC.component.scss']
})

export class RegistroCiudadanoUACCOMPONENT implements OnInit {

    @ViewChild("inputNombresApellidos") inputNombresApellidos: ElementRef;
    @ViewChild("inputCorreo") inputCorreo: ElementRef;
    @ViewChild("lectorCedula") lectorCedula: ElementRef;

    public modalGenerarTurno: ConfirmationModalOptions;
    public modalReImprimir: ConfirmationModalOptions;
    public dominios: DetalleDominio[] = [];
    public dominioDocumentos: DetalleDominio[] = [];
    public dominioSedes: DetalleDominio[] = [];
    public dominioGeneros: DetalleDominio[] = [];
    public dominioMotivoPrioridad: DetalleDominio[] = [];
    public dominioTipoDiscapacidad: DetalleDominio[] = [];
    public parametros: ParametrosUACModel[] = [];
    public paramSedeDefecto: string;
    public isPasaporte: boolean;
    public urlFtp: string;
    public visitante: VisitanteDTO;
    public agendaVitual: AgendaVirtualModel;
    public tramites: TramiteUACModel;
    public turnoUAC: TurnoUACModel = new TurnoUACModel();
    public url: string;
    public turnoImpreso: TurnoImpresoDTO;
    public cambioImagen: boolean = false;

    public lectorCedulaVal: string;
    public valorNuevo: string = '';


    //variables de control 
    public existeVisitante = false;
    public numeroTurno: string;
    public tieneTurnoProceso = false;

    //Variables provisionales
    public fotoVisitante;
    public campos: any;
    public htmlSticker: string;
    public htmlSticker2;

    public MENSAJE_CONFIRMACION: string;


    public numeroTabs = 0;

    prioridad = false;
    correoInvalido = false;



    public listaDominios: string[] = [DominiosService.DOMINIO_GENERO,
    DominiosService.DOMINIO_MOTIVO_PRIORIDAD,
    DominiosService.DOMINIO_TIPO_DISCAPACIDAD,
    DominiosService.DOMINIO_SEDE,
    DominiosService.DOMINIO_TIPO_IDENTIFICACION];

    public listaParametros: string[] = [DominiosService.SEDE_POR_DEFECTO];

    //variables de lector de codigos
    public valoresLector: string[] = [];




    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utils: UtilService,
        public router: Router,
        private modalService: NgbModal, 
        private sanitizer: DomSanitizer) {

        this.visitante = new VisitanteDTO();
        this.visitante.visitantePK = new VisitantePK();
        this.urlFtp = sessionStorage.getItem(ConstantesService.FTP_SESSSION);


        this.modalGenerarTurno =
            new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONF_GENERAR_TURNO,
                'SI', 'NO', 'fas fa-save', true, false, 'Generar turno',
                null, 'btn-secondary');
        this.modalReImprimir = new
            ConfirmationModalOptions('Exito', ' ', 'Reimprimir', 'Cerrar', ''
                , false, false, 'Reimprimir', undefined, 'btn-auxiliar');

    }

    ngOnInit() {
        this.consultarDominios();
        this.consultarParametros();
        this.consultarTramitesActivos();
        this.visitante.visitantePK.tipoDocVisitante = DominiosService.TIPO_DOCUMENTO_CC;
        this.lectorCedula.nativeElement.focus();
    }

    public checkPrioridad(){
 
        if (!this.turnoUAC.tienePrioridad) {
            this.turnoUAC.motivoPrioridad = undefined;
            this.turnoUAC.tipoDiscapacidad = undefined;
        }
        this.validarFormulario();

    }

    public validarFormulario() {
        if (this.validarCamposObligatorios()) {
            this.modalGenerarTurno.disabled = false;
        } else {
            this.modalGenerarTurno.disabled = true;
        }
    }





    public consultarDominios() {
        this.spinner.show();
        const serviceProvider = 'consultarDominios';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), AppSettings.API_INIT_ENDPOINT);
        this.global.postGenerico(url, this.listaDominios).subscribe(
            data => {
                this.dominios = data;
                this.filtrarDominios(this.dominios);
                this.spinner.hide();
            }, (err: any) => {
                this.cathException('Ocurrio un error en la consulta de los dominios');
            }
        );
    }



    public consultarTramitesActivos() {
        const serviceProvider = 'tramiteUAC';
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=estado', ConstantesService.ESTADO_TRAMITE_ACTIVO]);
        let url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
        url = url + '&orderBy=nombre$ASC';
        this.global.getGenerico(url).subscribe(
            data => {
                this.tramites = data;

            }, err => {
                this.cathException('Ocurrio un error en la consulta de los servicios');
            }
        );
    }

    public generarTurnoUAC() {
        this.turnoUAC.numDocVisitante = this.visitante.visitantePK.numDocVisitante;
        this.turnoUAC.tipoDocVisitante = this.visitante.visitantePK.tipoDocVisitante;
        const turnoGenerado: TurnoGeneradoModel = new TurnoGeneradoModel(this.visitante, this.turnoUAC);
        if (this.cambioImagen) {
            turnoGenerado.foto = this.fotoVisitante;
        }
        this.convertirNombresFuncionario();
        if (!this.turnoUAC.tienePrioridad) {
            this.turnoUAC.motivoPrioridad = undefined;
            this.turnoUAC.tipoDiscapacidad = undefined;
        }

        this.spinner.show();
        const serviceProvider = 'generarTurno';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        this.global.postGenerico(url, turnoGenerado).subscribe(
            data => {
                this.turnoImpreso = data;
                this.imprimir();
                this.modalReImprimir.message = `Se generó turno de atención ${this.turnoImpreso.turno} al ciudadano exitosamente`;
                $('.btn-auxiliar').click();
                this.spinner.hide();
            }, error => {
                this.spinner.hide();
                this.cathException(error);
            }
        );

    }

    /**
     * Metodo encargado de filtrar los dominios por cada una de las listas de seleccion
     * @function {filtrarDominios}
     * @param  {type} dominios: DetalleDominio[] {description}
     * @return {type} {description}
     */
    private filtrarDominios(dominios: DetalleDominio[]) {
        this.dominioDocumentos =
            dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_TIPO_IDENTIFICACION);       

        this.dominioSedes =
            dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_SEDE);

        this.dominioGeneros =
            dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_GENERO);

        this.dominioMotivoPrioridad =
            dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_MOTIVO_PRIORIDAD);

        this.dominioTipoDiscapacidad =
            dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_TIPO_DISCAPACIDAD);


    }


    private filtrarParametros() {
        this.paramSedeDefecto = this.retornarNombreParametro(DominiosService.SEDE_POR_DEFECTO);
        this.turnoUAC.sede = this.paramSedeDefecto;
    }

    private retornarNombreParametro(nombreParametro: string) {
        const parametroFiltro = this.parametros.filter(param => param.nombre === nombreParametro);
        return parametroFiltro.length > 0 && parametroFiltro[0] ? parametroFiltro[0].valor : undefined;

    }



    validarTipoDocumento() {
        if (this.visitante.visitantePK.tipoDocVisitante === DominiosService.TIPO_DOCUMENTO_PASAPORTE
            || this.visitante.visitantePK.tipoDocVisitante === DominiosService.TIPO_DOCUMENTO_EXTRANJERIA) {
            this.isPasaporte = true;
        } else {
            this.isPasaporte = false;
        }
        this.visitante.visitantePK.numDocVisitante = undefined;
    }

    private consultarParametros() {
        const serviceProvider = 'consultarParametros';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.postGenerico(url, this.listaParametros).subscribe(
            data => {
                this.parametros = data;
                this.filtrarParametros();
            });
    }

    public consultarPersona() {

        if (!this.utils.validarCamposObligatorios(this.visitante.visitantePK.numDocVisitante)
            || !this.utils.validarCamposObligatorios(this.visitante.visitantePK.tipoDocVisitante)) {
            return;
        }
        const serviceProvider = 'ObtenerVisitante';
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=visitantePK.numDocVisitante', this.visitante.visitantePK.numDocVisitante]);
        pathParams.push(['visitantePK.tipoDocVisitante', this.visitante.visitantePK.tipoDocVisitante]);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data.length > 0) {
                    this.visitante = data[0];
                    this.existeVisitante = true;
                    this.procesarFoto();
                    this.consutarTurnoProceso();
                    this.validarFormulario();
                    this.procesarNombre();
                } else {
                    this.existeVisitante = false;
                }
            }, err => {
                this.cathException('Se presentó un problema al consultar los datos del ciudadano');
            });
    }

    public consultarAgendaVigente() {
        this.spinner.show();
        const serviceProvider = 'consultarAgendaVigente';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.visitante.visitantePK.tipoDocVisitante]);
        queryParams.push(['numeroDocumento', this.visitante.visitantePK.numDocVisitante]);
        queryParams.push(['sede', this.paramSedeDefecto]);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);

        this.global.getGenerico(url).subscribe(
            data => {
                if (data.length > 0) {
                    this.agendaVitual = data[0];
                    this.llenarInformacionTurno();
                } else {
                    this.agendaVitual = undefined;
                }
                this.validarFormulario();
                this.spinner.hide();
            }, error => {
                this.cathException(error);
            }
        );

    }


    public consutarTurnoProceso() {
        this.spinner.show();
        const serviceProvider = 'consutarTurnoProceso';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.visitante.visitantePK.tipoDocVisitante]);
        queryParams.push(['numeroDocumento', this.visitante.visitantePK.numDocVisitante]);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);

        this.global.getGenerico(url).subscribe(
            data => {
                if (data.length > 0) {
                    this.tieneTurnoProceso = true;
                    const mensajeTurno = 'El cuidadano ya tiene un turno asignado y se encuentra en proceso, no es posible asignar un nuevo turno';
                    this.cathException(mensajeTurno);
                } else {
                    this.tieneTurnoProceso = false;
                    this.validarFormulario();
                    this.consultarAgendaVigente();
                    this.inputCorreo.nativeElement.focus();
                }
            }
        );

    }



    private llenarInformacionTurno() {
        this.turnoUAC.idTramite = this.agendaVitual.tramite;
        this.turnoUAC.tienePrioridad = this.agendaVitual.motivoPrioridad ? true : false;
        this.turnoUAC.motivoPrioridad = this.agendaVitual.motivoPrioridad;
        this.turnoUAC.tipoDiscapacidad = this.agendaVitual.tipoDiscapacidad;
        this.turnoUAC.idAgendaVirtual = this.agendaVitual.idAgendaVirtual;
        this.turnoUAC.sede = this.agendaVitual.sede;
    }

    private refrescarPagina() {
        this.lectorCedula.nativeElement.focus();
        this.visitante = new VisitanteDTO();
        this.visitante.visitantePK = new VisitantePK();
        this.turnoUAC = new TurnoUACModel();
        this.fotoVisitante = undefined;
        this.cambioImagen = false;
        this.turnoUAC.sede = this.paramSedeDefecto;
        this.existeVisitante = false;
        this.tieneTurnoProceso = false;
        this.turnoImpreso = undefined;
        this.visitante.visitantePK.tipoDocVisitante =  DominiosService.TIPO_DOCUMENTO_CC;
        this.validarFormulario();
    }



    vermodalacamara() {

        const modalRef = this.modalService.open(ComponenteCameraComponent, { centered: false, size: 'lg' });
        modalRef.result.then((result) => {
            this.cambioImagen = true;
            this.fotoVisitante = result.imageAsDataUrl.imageAsDataUrl;
            this.validarFormulario();

        });
    }


    dataURItoBlob(dataURI): Blob {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'image/jpeg' });
        return blob;
    }

    public validarCamposObligatorios() {
        return !this.tieneTurnoProceso && this.validarFoto()
            && this.utils.validarCamposObligatorios(this.turnoUAC.idTramite)
            && this.visitante.visitantePK && this.utils.validarCamposObligatorios(this.visitante.visitantePK.numDocVisitante)
            && this.utils.validarCamposObligatorios(this.visitante.visitantePK.tipoDocVisitante)
            && this.utils.validarCamposObligatorios(this.visitante.nombres)
            && this.utils.validarCamposObligatorios(this.visitante.apellidos)
            && this.utils.validarCamposObligatorios(this.visitante.genero)
            && this.utils.validarCamposObligatorios(this.visitante.telefono)
            && this.utils.validarCamposObligatorios(this.turnoUAC.sede)
            && this.utils.validarCamposObligatorios(this.turnoUAC.idTramite)
            && this.validarPrioridad()
            && !this.correoInvalido;

    }

    private validarPrioridad() {
        return !this.turnoUAC.tienePrioridad ||
            (this.utils.validarCamposObligatorios(this.turnoUAC.motivoPrioridad) &&
                this.turnoUAC.motivoPrioridad !== DominiosService.MOTIVO_PRIORIDAD_DISCAPACIDAD) ||
            this.utils.validarCamposObligatorios(this.turnoUAC.tipoDiscapacidad);
    }

    private validarFoto() {
        return this.utils.validarCamposObligatorios(this.fotoVisitante)
            || this.utils.validarCamposObligatorios(this.visitante.urlFoto);
    }



    public validarCorreo() {
        this.correoInvalido = this.utils.validarCamposObligatorios(this.visitante.correoVisitante)
            && this.utils.validarCorreo(this.visitante.correoVisitante);
    }

    public getConfirmationModalTajeta(event) {
        if (event[0] === true) {
            this.generarTurnoUAC();
        }
    }

    public getReImprimirModal(event) {
        if (event[0] === true) {
            this.imprimir();
        }
        this.refrescarPagina();
    }

    private procesarFoto() {
         
        if (this.urlFtp && this.urlFtp != '' && this.visitante.urlFoto) {
            let valor = Math.random();
            this.fotoVisitante = this.urlFtp + this.visitante.urlFoto + `?random=${valor}`; 
        }

    }

    private procesarNombre() {
        this.visitante.nombres = (this.visitante.primerNombre ? this.visitante.primerNombre : '') +
                (this.visitante.segundoNombre ? ' ' + this.visitante.segundoNombre  : '');
        this.visitante.apellidos = (this.visitante.primerApellido ? this.visitante.primerApellido : '' ) +
                (this.visitante.segundoApellido ?  ' ' + this.visitante.segundoApellido : '');
    }

    imprimir() {
        const frame = 'print_frame_turno';
        this.reemplazarCampos();
        window.frames[frame].document.body.innerHTML = this.htmlSticker;
                
        var newWindow = window.open(this.htmlSticker, 'Dynamic Popup', 'height=' + 'auto' + ', width=' + 'auto' + 'scrollbars=auto, resizable=no, location=no, status=no');
        newWindow.document.write(this.htmlSticker);
        //window.frames[frame].window.focus();
        setTimeout(() => {
            //window.frames[frame].window.print();            
            newWindow.print();
            newWindow.close();
            window.frames[frame].document.body.innerHTML = '';
        }, 100);
    }


    reemplazarCampos() {
        this.htmlSticker = this.turnoImpreso.plantillaTurno;
        const fechaActual = new Date();
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        this.turnoImpreso.hora = fechaActual.getHours() + ':' + 
        (fechaActual.getMinutes() >= 10 ? fechaActual.getMinutes() : '0' + fechaActual.getMinutes() ) + ':'
        + (fechaActual.getSeconds() >= 10 ? fechaActual.getSeconds() : '0' + fechaActual.getSeconds());
        
        this.turnoImpreso.fecha = fechaActual.toLocaleDateString('es-ES', options);
        const nombreAtributos = Object.getOwnPropertyNames(this.turnoImpreso);
        for (const nombre of nombreAtributos) {
            this.htmlSticker = this.htmlSticker.replace('[' + nombre + ']', this.turnoImpreso[nombre]);
        }
    }




    /**
     * Método de control de Excepciones
     * @param  error mensaje saliente respecto al error ocurrido
     * @return void
     */
    cathException(error: any) {
        if (typeof error === 'string') {
            this.alertService.generateAlertError(error, 'Error');
        } else if (error.message && error.error.message && error.error.message.length < 200 &&
            !error.error.message.includes('EJB')) {
            this.alertService.generateAlertError(error.error.message, 'Error');
        } else {
            this.alertService.generateAlertError('Ocurrio un error,por favor intente más tarde', 'Error');
        }
        this.spinner.hide();
    }

    eventFocus(){
        this.valorNuevo = '';
        this.valoresLector = [];
    }


    onKeyLector(event: KeyboardEvent) {
        if (event.key === 'Shift' || event.key === 'Alt' || event.key ===  'CapsLock') {
            return;
        }

        if (event.key === 'Tab') {
            this.valoresLector.push(this.valorNuevo);
            this.valorNuevo = '';
        } else {
            this.valorNuevo += event.key;
        }

        event.preventDefault();
        this.lectorCedula.nativeElement.focus();
        if (event.key === 'Enter') {
            if (this.valoresLector.length > 5) {
                this.procesarLector();
            }
            this.valorNuevo = '';
            this.valoresLector = [];
        }
    }

    private procesarLector() { 
        this.visitante.visitantePK.tipoDocVisitante = DominiosService.TIPO_DOCUMENTO_CC;
        this.visitante.visitantePK.numDocVisitante = this.valoresLector[0].replace(/^00/, '');
        this.visitante.nombres = this.valoresLector[3] + ' ' + this.valoresLector[4];
        this.visitante.apellidos = this.valoresLector[1] + ' ' + this.valoresLector[2] ;
        this.visitante.genero = this.valoresLector[5] === 'M' ? DominiosService.GENERO_MASCULINO : DominiosService.GENERO_FEMENINO ;
        this.inputCorreo.nativeElement.focus();
        this.consultarPersona();
    }




    mychange(event) {
        if (this.numeroTabs >= 4) {
            this.visitante.correoVisitante = '';
            this.visitante.telefono = '';
            this.numeroTabs = 0;
            this.consultarPersona();
            this.validarCorreo();
        }
    }

    convertirNombresFuncionario() {
        const nombresSeparados = this.utils.separarString(this.visitante.nombres.trim());
        const apellidosSeparados = this.utils.separarString(this.visitante.apellidos.trim());
        this.visitante.nombreCompleto = this.visitante.nombres.trim() + ' ' + this.visitante.apellidos.trim();
        this.visitante.primerNombre = nombresSeparados[0];
        this.visitante.segundoNombre = nombresSeparados[1] ? nombresSeparados[1].trim() : nombresSeparados[1];
        this.visitante.primerApellido = apellidosSeparados[0];
        this.visitante.segundoApellido = apellidosSeparados[1] ? apellidosSeparados[1].trim() : apellidosSeparados[1];
    }


}
